export default __webpack_public_path__ + "static/media/blogCategories.7ed4da1b.svg";